<h4 class="tw-mb-2">Equivalentes requeridos</h4>
<ng-container *ngFor="let cat of categories">
    <ng-container *ngIf="mealTime.metadata.nutrientTable[cat._id] > 0">
        <div class="text-info tw-flex tw-items-center tw-h-6 tw-mb-4 tw-ml-1">
            <img class="tw-h-full tw-w-auto tw-max-h-5" [src]="iconsRoute + iconsName[cat._id]"
                [alt]="iconsName[cat._id]">
            <div class="tw-ml-2">
                <p>{{ cat.name }} ({{ mapCategoryPortions[cat._id]?.toFixed(2) || 0.00 }} / {{
                    mealTime.metadata.nutrientTable[cat._id]?.toFixed(2) }})</p>
                <app-steps-progress-bar [colorStepBefore]="'rgb(89 169 230)'" [colorStepAfter]="'rgb(227 96 98)'"
                    [stepsMeta]="mealTime.metadata.nutrientTable[cat._id]"
                    [stepsReal]="mapCategoryPortions[cat._id]"></app-steps-progress-bar>
            </div>
        </div>
    </ng-container>
</ng-container>

<ng-container *ngIf="extraIngredients">
    <h4 class="tw-mb-2 tw-mt-6">Extras</h4>
    <ng-container *ngFor="let cat of categories">
        <ng-container *ngIf="mapCategoryPortions[cat._id] && !mapCategoryIsRequired[cat._id]">
            <div class="text-info tw-flex tw-items-center tw-h-6 tw-mb-4 tw-ml-1">
                <img class="tw-h-full tw-w-auto tw-max-h-5" [src]="iconsRoute + iconsName[cat._id]"
                    [alt]="iconsName[cat._id]">
                <div class="tw-ml-2">
                    <p>{{ cat.name }} ({{ mapCategoryPortions[cat._id]?.toFixed(2) || 0.00 }})</p>
                    <app-steps-progress-bar [colorStepBefore]="'rgb(89 169 230)'" [colorStepAfter]="'rgb(227 96 98)'"
                        [stepsMeta]="mapCategoryPortions[cat._id]"
                        [stepsReal]="mapCategoryPortions[cat._id]"></app-steps-progress-bar>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-container>



<!-- <ng-container *ngFor="let cat of categories">
    <img class="tw-h-full tw-w-auto tw-max-h-5" [src]="iconsRoute + iconsNameA[cat._id]">
</ng-container>
<br>
<ng-container *ngFor="let cat of categories">
    <img class="tw-h-full tw-w-auto tw-max-h-5" [src]="iconsRoute + iconsNameB[cat._id]">
</ng-container> -->